import { apiInstanceWithToken } from "../integrations/ApiInstance";
import "react-toastify/dist/ReactToastify.css";
import {
  adminEndpoints
} from "../integrations/ApiEndpoints";

import { showErrorToast } from "../utils/Toasts";
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 


export const runOneTimeAdminExecution = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(adminEndpoints.runOneTimeAdminExecution, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "failed..." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE - END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 